import {SHEET_SET} from './types';

export const showSheet = (payload: {sheetId: string; modalProps?: {}}) => ({
  type: SHEET_SET,
  payload,
});
